import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from 'vue';
import { useMediaQuery } from '@vueuse/core';
import { SidebarContent } from '../../primitives/sidebar';
import { provideSidebarContext } from '../../primitives/sidebar/utils';
import { TooltipProvider } from '../../primitives/tooltip';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnSidebar',
    props: {
        rail: { type: Boolean, required: false, default: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const sidebarState = computed(() => (props.rail ? 'collapsed' : 'expanded'));
        const sidebarOpen = computed(() => !props.rail);
        const openMobile = ref(false);
        const isMobile = useMediaQuery('(max-width: 768px)');
        provideSidebarContext({
            state: sidebarState,
            open: sidebarOpen,
            setOpen: () => { },
            isMobile,
            openMobile,
            setOpenMobile: (val) => { openMobile.value = val; },
            toggleSidebar: () => { },
        });
        const __returned__ = { props, sidebarState, sidebarOpen, openMobile, isMobile, get SidebarContent() { return SidebarContent; }, get TooltipProvider() { return TooltipProvider; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
